<template>
  <div class="login-wrapper">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>

<script>
import Login2Col from './Login_2Col.vue'
import LoginCenter from './Login_Center.vue'
export default {
  name: 'Login',
  components: {
    Login2Col,
    LoginCenter
  },
  data () {
    return {
      layout: '',
      ready: false
    }
  },
  mounted () {
    window.localStorage.removeItem('view-mode')
    if (this.$route.query.mode === 'henan') {
      window.localStorage.setItem('view-mode', 'migrantworker-only')
    } else if (this.$route.query.mode === 'puyang') {
      window.localStorage.setItem('view-mode', 'puyang')
    }
    if (this.$route.query.business) {
      window.localStorage.setItem('business-type', this.$route.query.business)
    }
    if (this.$store.getters.sysConfigs['LOGIN_LAYOUT_NAME']) {
      this.layout = `Login${this.$store.getters.sysConfigs['LOGIN_LAYOUT_NAME']}`
      this.ready = true
    } else {
      this.layout = 'Login2Col'
      this.ready = true
    }
  }
}
</script>